import './App.css';
import Carousel from './components/carousel';
import Header from './components/header';

function App() {
  return (
    <div>
      <Header/>
      <Carousel/>
   </div>
  );
}

export default App;
